<template>
  <div>

  </div>
</template>

<script>
//import HelperFunctions from '@/assets/HelperFunctions.js'

export default {
  data() {
    return {
      numberOfSteps: 0
    }
  },
  created() {
    if(this.$DeviceCheck.isMobile) { this.numberOfSteps = 11; } else { this.numberOfSteps = 6; }
  },
  mounted() {
    this.$nextTick(() => {
      const tour = this.$shepherd({
        useModalOverlay: true,
        defaultStepOptions: {
          classes: 'shepherd-element shepherd-open shepherd-theme-arrows',
          scrollTo: false,
          cancelIcon: {
            enabled: true,
            label: 'Luk vejledning'
          },
          when: {
            cancel: () => {
              //console.log('IntroTutorialCancel');
              localStorage.setItem('OdenseRundt-TutorialIntro', 'false');
              this.$HelperFunctions.trackSession('intro-tutorial', 'intro-tutorial-closed');
              //app.introTutorialActive = false;
            }
          }
        }
      });

      tour.addStep({
        id: 'intro-welcome',
        text: '<h4 id="intro-tutorial-headline">Velkommen til Odense Rundt.</h4>Her kan du finde information om vejarbejde og parkering, beregne din rute på hele Fyn og få inspiration til oplevelser i Odense.<br><br>\
        Find fx legepladser, naturområder, turforslag og meget andet. Odense Rundt viser dig vej derhen både i bil, på cykel og til fods. <br><div class="tutorial-step-counter">1/'+this.numberOfSteps+'</div>',
        buttons: [
          {
            text: 'Næste',
            classes: 'shepherd-button-primary blue',
            action: () => {
              tour.next();
              this.$HelperFunctions.trackSession('intro-tutorial', 'intro-welcome-next');
            }
          }
        ]
      });

      var text = '';
      if(this.$DeviceCheck.isMobile) {
        text = 'Vælg, om du vil have indholdet på Odense Rundt vist tematisk, alfabetisk eller ud fra vores forslag.<br><div class="tutorial-step-counter">2/'+this.numberOfSteps+'</div>';
      }
      else {
        text = '<strong>Temaer</strong> viser en tematisk oversigt over indholdet på Odense Rundt.<br><br>\
        <strong>Forslag</strong> viser nyt eller aktuelt indhold på Odense Rundt.<br><br>\
        <strong>A-Å</strong> viser en alfabetisk oversigt over indholdet på Odense Rundt.<br><div class="tutorial-step-counter">2/'+this.numberOfSteps+'</div>';
      }

      tour.addStep({
        id: 'intro-themes',
        text: text,
        attachTo: {
          element: '#explore-tabs',
          on: 'bottom'
        },
        buttons: [
          {
            text: 'Tilbage',
            classes: 'shepherd-button-secondary',
            action: tour.back
          }, {
            text: 'Næste',
            classes: 'shepherd-button-primary blue',
            action: () => {
              tour.next();
              this.$HelperFunctions.trackSession('intro-tutorial', 'intro-theme-menu-next');
            }
          }
        ]
      });

      tour.addStep({
        id: 'intro-favorite',
        text: 'Tilføj favoritter ved at klikke på hjertet på det enkelte billede <span class="material-icons icon-medium">favorite_border</span><br><div class="tutorial-step-counter">3/'+this.numberOfSteps+'</div>',
        buttons: [
          {
            text: 'Tilbage',
            classes: 'shepherd-button-secondary',
            action: tour.back
          }, {
            text: 'Næste',
            classes: 'shepherd-button-primary blue',
            action: () => {
              this.$HelperFunctions.trackSession('intro-tutorial', 'intro-favorites-next');
              if(this.$DeviceCheck.isMobile) {
                $('#mobile-menu-toggle').click();
              }
              setTimeout(() => {
                tour.next();
              }, 500);
            }
          }
        ]
      });

      if(this.$DeviceCheck.isMobile) {
        tour.addStep({
          id: 'intro-profile',
          text: 'I menuen finder du din profil, der bl.a indeholder dine favoritter.<br><br>\
          Under din profil kan du også tilføje foretrukne adresser, indstille din cykelhastighed, gruppere dine favoritter m.m.<br><div class="tutorial-step-counter">4/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#mobile-profile-anchor',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-mobile-profile-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-mobile-recommended',
          text: '<strong>Forslag</strong> viser nyt eller aktuelt indhold på Odense Rundt.<br><div class="tutorial-step-counter">5/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#mobile-recommended-anchor',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-mobile-recommended-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-mobile-themes',
          text: '<strong>Temaer</strong> viser en tematisk oversigt over indholdet på Odense Rundt.<br><div class="tutorial-step-counter">6/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#mobile-themes-anchor',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-mobile-themes-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-mobile-alphabetic',
          text: '<strong>A-Å</strong> viser en alfabetisk oversigt over indholdet på Odense Rundt.<br><div class="tutorial-step-counter">7/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#mobile-alphabetic-anchor',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-mobile-alphabetic-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-mobile-routeplanner',
          text: 'På Ruteplanlæggeren kan du få vist den anbefalede rute i bil, på cykel og til fods.<br><br>\
          Rutevejledningen tager højde for aktuelle vejlukninger, ensretninger osv. i hele Odense.<br><div class="tutorial-step-counter">8/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#mobile-routeplanner-anchor',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-mobile-routeplanner-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-mobile-contact',
          text: 'Kontakt os gerne om fejl og mangler, eller hvis du har forslag til nyt indhold på Odense Rundt.<br><div class="tutorial-step-counter">9/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#mobile-contact-anchor',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-mobile-contact-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-mobile-help',
          text: 'Få hjælp til, hvordan du kan bruge Odense Rundt.<br><div class="tutorial-step-counter">10/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#mobile-help-anchor',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-mobile-help-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-mobile-about',
          text: 'Mere information om Odense Rundt.<br><div class="tutorial-step-counter">11/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#mobile-about-anchor',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Luk',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.complete();
                //console.log('IntroTutorialComplete');
                localStorage.setItem('OdenseRundt-TutorialIntro', 'false');
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-tutorial-complete');
                //app.introTutorialActive = false;
                if(this.$DeviceCheck.isMobile) {
                  $('#mobile-menu-toggle').click();
                }
              }
            }
          ]
        });
      }
      else {
        tour.addStep({
          id: 'intro-routeplanner',
          text: 'I menuen finder du Ruteplanlæggeren, hvor kan få vist den anbefalede rute i bil, på cykel og til fods.<br><br>\
          Rutevejledningen tager højde for aktuelle vejlukninger, ensretninger osv. i hele Odense.<br><div class="tutorial-step-counter">4/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#top-bar-nav',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-pc-routeplanner-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-menu',
          text: 'I menuen finder du hjælp, til hvordan du bruger Odense Rundt og muligheden for at kontakte os.<br><br>\
          Kontakt os gerne om fejl og mangler, eller hvis du har forslag til nyt indhold på Odense Rundt.<br><div class="tutorial-step-counter">5/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#top-bar-nav',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-pc-help-contact-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'intro-profile',
          text: 'Længst til højre finder du din profil, der bl.a indeholder dine favoritter.<br><br>\
          Her kan du også tilføje foretrukne adresser, indstille din cykelhastighed, gruppere dine favoritter m.m.<br><div class="tutorial-step-counter">6/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#top-bar-nav',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Luk',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.complete();
                //console.log('IntroTutorialComplete');
                localStorage.setItem('OdenseRundt-TutorialIntro', 'false');
                this.$HelperFunctions.trackSession('intro-tutorial', 'intro-tutorial-complete');
                //app.introTutorialActive = false;
              }
            }
          ]
        });
      }

      tour.start();
      /*app.introTutorialActive = true;
      app.setScreenReaderFocus('intro-tutorial-headline');*/
    });
  }
};
</script>
